import React from 'react';
import type { TimeOffTypeDialogModel } from '../schedule/TimeOffTypeDialogModel';
import DefaultEditPanelFormView from './DefaultEditPanelFormView';
import SettingsModel, { useWatch } from './SettingsModel';

export default React.memo(({ editor }: { editor: TimeOffTypeDialogModel; settings: SettingsModel }) => {
  const form = editor.form;
  useWatch(
    () => form.field?.['start']?.value,
    () => {
      const startValue = form.field?.['start']?.value;
      form.field['monthDay'].visible = startValue === 'Month/Day';
      form.field['seniority'].visible = startValue === 'Seniority Date';
    },
    true,
  );

  useWatch(
    () => form.field?.['expiry']?.value,
    () => {
      const expiryValue = form.field?.['expiry']?.value;
      form.field['years'].visible = expiryValue === 'x Years After Start';
    },
    true,
  );

  if (!editor) return null;

  return <DefaultEditPanelFormView editor={editor} />;
});
